<div class="min-h-screen w-screen">
  <div class="h-16 xl:h-20 w-full">
    <app-header/>
  </div>
  <div class="flex h-[calc(100vh-var(--spacing)*16)] xl:h-[calc(100vh-var(--spacing)*20)]">
    <div class="h-full w-0" [ngClass]="{'xl:w-70': isExpanded() && !isFullscreen()}">
      <app-sidebar></app-sidebar>
      <app-backdrop></app-backdrop>
    </div>
    <div class="flex-1 w-full transition-all duration-300 ease-in-out h-full overflow-hidden"
        [ngClass]="{'xl:w-[calc(100%-var(--spacing)*70)]': isExpanded() && !isFullscreen()}"
    >
      <div class="mx-auto w-full h-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>